<template>
  <div class="container">
    <div class="common-header-wrap">
      <mt-header title="消费积分明细" class="common-header">
        <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
      </mt-header>
    </div>
    <div v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
    <div
      class="list-wrapper"
      v-if="point_list && point_list.length"
    >
      <div
        class="point-list"
        v-for="(item, index) in point_list"
        :key="item.pl_id"
      >
	  <label class="title" v-bind:class="item.pl_points > 0 ? 'income' : 'expend'">{{ item.pl_points }}</label>
	  <label class="subtitle">{{ item.pl_desc }}</label>
	  <label class="date">{{ item.addtimetext }}</label>	  
      </div>
    </div>
    <empty-record v-else-if="point_list && !point_list.length"></empty-record>
  </div>
  </div>
</template>

<script>
import { getPointList } from '../../../api/memberPoint'
import { Toast, Indicator } from 'mint-ui'
import EmptyRecord from '../../../components/EmptyRecord'
export default {
  name: 'BalanceHistory',
  components: {
    EmptyRecord
  },
  data () {
    return {
      params: { 'page': 0, 'per_page': 10 },
      loading: false, // 是否加载更多
      isMore: true, // 是否有更多
      wrapperHeight: 0,

      point_list: false
    }
  },
  created () {

  },
  mounted () {
    this.wrapperHeight = document.documentElement.clientHeight - 90
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    loadMore () {
      this.loading = true
      this.params.page = ++this.params.page
      if (this.isMore) {
        this.loading = false
        this.getPointList(true)
      }
    },
    getPointList () {
      Indicator.open()
      getPointList(this.params).then(res => {
        Indicator.close()
        if (res.result.hasmore) {
          this.isMore = true
        } else {
          this.isMore = false
        }

        let temp = res.result.log_list
        if (temp) {
          if (!this.point_list) {
            this.point_list = temp
          } else {
            this.point_list = this.point_list.concat(temp)
          }
        }
      }).catch(function (error) {
        Indicator.close()
        Toast(error.message)
      })
    }
  }
}
</script>

<style scoped lang="scss">
.container {
  height: 100%;
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
}
.header {
  border-bottom: 1px solid #e8eaed;
}
.list-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  .point-list {
	display: flex;
	position: relative;
	flex-direction: column;
	justify-content: flex-start;
	align-items: stretch;
	background-color: #fff;
	border-bottom: 1px solid #e8eaed;
	.title {
	font-size:$h1;
	margin-left:0.7rem;
	margin-top:0.7rem;
	}
	.subtitle {
	font-size:$fontSize;
	color: #666;
	margin-left:0.7rem;
	margin-top:0.4rem;
	margin-bottom:0.5rem;
	}
	.income {
	color: $primaryColor;
	}
	.expend {
	color: #333;
	}
	.date {
	color: #666;
	font-size:$subFontSize;
	position: absolute;
	top:0.9rem;
	right: 0.7rem;
	}
  }
}
</style>
